import React, { useState } from 'react';
export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. La guía está pensada para personas que arrancan de cero. Todo está explicado paso a paso, desde cómo identificar el oro hasta cómo hacer tu primera operación.'
  }, {
    q: '¿Cuánto capital necesito para empezar?',
    a: 'Podés arrancar con menos de USD 200. Las herramientas básicas (balanza, kit de ácidos, lupa) cuestan menos de USD 100 en total. El resto es tu capital para la primera compra.'
  }, {
    q: '¿Los precios del ebook están actualizados?',
    a: 'Los precios son referenciales al momento de edición (marzo 2026). La guía te enseña a calcular el precio exacto del día usando el precio internacional del oro y el dólar blue vigente.'
  }, {
    q: '¿Sirve si no vivo en Buenos Aires?',
    a: 'Sí. Los conceptos de quilates, pruebas de autenticidad y cálculo de valor aplican en todo el país. Las zonas de CABA son referencia, pero podés operar en cualquier ciudad con ferias, joyerías o redes sociales.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Es un producto digital. Al pagar, recibís acceso inmediato a la guía completa en PDF, los 3 bonos (PDFs + Excel) y el plan de acción de 7 días. Todo descargable al instante.'
  }, {
    q: '¿Es legal comprar y vender oro en la calle?',
    a: 'La guía incluye un módulo sobre aspectos legales básicos: inscripción en AFIP, monotributo, habilitación comercial y registro de compras. Te explica cómo operar en regla para crecer sin problemas.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Tenés 7 días de garantía. Si no te sirve, pedís el reembolso y listo. Sin preguntas.'
  }];
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20" style={{
    background: 'var(--bg-card)'
  }} data-id="element-51">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-52">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-53">
          Preguntas Frecuentes
        </h2>

        <div data-id="element-54">
          {faqs.map((faq, idx) => <div key={idx} className="py-5 cursor-pointer" style={{
          borderBottom: '1px solid var(--border-subtle)'
        }} onClick={() => toggleAccordion(idx)} data-id="element-55">
              <div className="flex justify-between items-center" data-id="element-56">
                <span className="font-semibold text-base pr-8" style={{
              color: 'var(--text-primary)'
            }} data-id="element-57">
                  {faq.q}
                </span>
                <span className="text-2xl transition-transform duration-300 flex-shrink-0" style={{
              color: 'var(--gold)',
              transform: openIndex === idx ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-58">
                  +
                </span>
              </div>
              <div className="overflow-hidden transition-all duration-400" style={{
            maxHeight: openIndex === idx ? '200px' : '0',
            paddingTop: openIndex === idx ? '12px' : '0'
          }} data-id="element-59">
                <p className="text-sm leading-relaxed" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-60">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};